import { render, staticRenderFns } from "./RenjiDetail.vue?vue&type=template&id=4b55de88&scoped=true"
var script = {}
import style0 from "./RenjiDetail.vue?vue&type=style&index=0&id=4b55de88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55de88",
  null
  
)

export default component.exports